import React, { Component } from 'react'
import { Row, Typography, Button, Comment, List, Tooltip, Input, DatePicker, message, Avatar, Tag, Skeleton, Spin, Select, Badge, Radio, Collapse } from 'antd';
import { RESTExecutor, withDomains } from '../lib/domain';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { showErrorInNotification, showSuccessInNotification } from '../lib/util';
import { CustomButton } from './basic_items';
import FilterFixedInput from './filter_fixed_input';
import { COLORS } from '../pages/theme';
import { DoneAll } from '@material-ui/icons';
import APP_CONFIG from '../config';


const { Title, Text } = Typography;
const count = 3;

const REFERENCE_FOR_CIVIL = [
    "008; Issuer Timeout",
    "NO EJ",
    "Incomplete EJ",
    "NO TRACE. (Timeout)",
    "No Trace",
    "103; Unable to Dispense",
    "096; System Malfunction",
    "HARD DRIVE CRASH. NO EJ",
    "046; Switch Not Available",
    "Cash Dispense failed",
    "COMMUNICATION ERROR; No Trace",
    "CASH RETRACTED",
    "Cash Retained",
    "CDM ERROR; ERROR DURING CASH RETRACT",
    "AUTO REVERSE IN NETWORK",
    "Reverse in network"
]


class CommentPage extends Component {
    constructor(props) {
        super(props)

        this.current_page = 1;

        this.active_notif_id = null;


        this.state = {
            comment_data: { type: 0 },
            initLoading: true,
            loading: false,
            final_data: false,
            data: [],
            list: [],
            completed_comment_ids: [],
            processing_id: null
        };

        this.list_comments = RESTExecutor.list().forId(this.props.dataID).config({
            label: 'comments',
            params: {
                per_page: count,
                page: 1
            }
        }).callbacks((success) => {
            let pagination = (success.meta.pagination || "0/0").split("/");
            let final_data = false;
            if (pagination[0] >= pagination[1]) {
                final_data = true
            }
            this.setState({
                initLoading: false,
                data: success.result.rows,
                list: success.result.rows,
                final_data: final_data
            })
        }).connect(props.domains.allData);

        this.post_comments = RESTExecutor.post().config({
            label: 'comments'
        }).callbacks((success) => {
            this.current_page = 1

            this.setState({
                comment_data: { type: 0 },
                initLoading: true,
                loading: false,
                final_data: false,
                data: [],
                list: [],
            }, () => {
                this.list_comments.
                    config({
                        params: {
                            per_page: count,
                            page: 1
                        }
                    }).callbacks((success) => {
                        let pagination = (success.meta.pagination || "0/0").split("/");
                        let final_data = false;
                        if (pagination[0] >= pagination[1]) {
                            final_data = true
                        }
                        this.setState({
                            initLoading: false,
                            data: success.result.rows,
                            list: success.result.rows,
                            final_data: final_data
                        })
                    }).execute();
            })

        }, (error) => {
            showErrorInNotification(error);
            //   message.error("Failed to submit comment. Please try again.")
        }).connect(props.domains.allData);


        this.mark_done_followups = RESTExecutor.patch().config({
            label: 'followups_done'
        }).callbacks((success) => {
            showSuccessInNotification(success, "Task Completed");
            this.setState({
                completed_comment_ids: [...this.state.completed_comment_ids, this.state.processing_id],
                processing_id: null
            })
        }, (error) => {
            showErrorInNotification(error)
            this.setState({
                processing_id: null
            })
            // message.error("Failed to mark done")

        }).connect(props.domains.myTask);


        this.list_comments.execute()
    };

    stateUpdater = (stateKey, key, value, callback) => {
        let newData = this.state[stateKey];
        newData[key] = value;
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback();
        })
    }

    onLoadMore = () => {
        this.setState({
            loading: true,
            list: this.state.data.concat([...new Array(count)].map(() => ({ loading: true, name: {} }))),
        });
        this.list_comments.config({
            params: {
                per_page: count,
                page: this.current_page + 1
            }
        }).callbacks((success) => {
            let pagination = (success.meta.pagination || "0/0").split("/");
            let final_data = false;
            if (pagination[0] >= pagination[1]) {
                final_data = true
            }

            this.current_page += 1;
            const data = this.state.data.concat(success.result.rows);
            this.setState({
                data,
                list: data,
                loading: false,
                initLoading: false,
                final_data: final_data
            }, () => {
            })

        }, (error) => {

        }).execute()

        //   this.getData(res => {
        //     const data = this.state.data.concat(res.results);
        //     this.setState(
        //       {
        //         data,
        //         list: data,
        //         loading: false,
        //       },
        //       () => {
        //         // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
        //         // In real scene, you can using public method of react-virtualized:
        //         // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
        //         window.dispatchEvent(new Event('resize'));
        //       },
        //     );
        //   });
    }

    render() {

        // console.log(this.props.dataID)
        if (!this.props.dataID) {
            return <div>There was some error</div>
        }


        let auth_data = this.props.authenticator.getTokens();
        console.log("data is", auth_data)
        let auth_meta = auth_data.meta || {};
        let user_data = auth_meta.user_data || {};

        let total_process_list = this.props.rules_list || []
        let location = this.props.location || {};
        console.log("comment props location", location)
        let state = location.state || {};
        this.active_notif_id = state.clicked_notif_id;


        let comments_res = this.list_comments.response();
        let post_comments_res = this.post_comments.response();
        let comments_data = comments_res.result || {};
        const { comment_data } = this.state;
        const { initLoading, loading, list, final_data, completed_comment_ids, processing_id } = this.state;

        const loadMore =
            !final_data ? (
                (!initLoading && !loading) ? (
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 12,
                            height: 32,
                            lineHeight: '32px',
                        }}
                    >
                        <Button onClick={this.onLoadMore}>Load more</Button>
                    </div>
                ) : null
            )
                :
                <Text type='secondary'>{list.length !== 0 && "No More Comments"}</Text>


        return (
            <div>
                <Collapse accordion style={{
                    backgroundColor: 'transparent'
                }} bordered={false} expandIconPosition='right'
                    defaultActiveKey='activity'
                >
                    <Collapse.Panel header={<span className='heading-2'>Recent Activities</span>} key='activity'>
                        {
                            initLoading ? <Spin />
                                :
                                <React.Fragment>
                                    <List
                                        className="comment-list"
                                        // header={`Recent Activities`}
                                        itemLayout="horizontal"
                                        loading={initLoading}
                                        loadMore={loadMore}

                                        dataSource={list}
                                        renderItem={item => {

                                            let reference = item.__references__ || {};
                                            let recon_rule = reference.rule_id || {};
                                            let created_by = reference.created_by || {};
                                            let user_label = (typeof created_by.name === 'string' ? created_by.name.split(' ').map(i => i.charAt(0).toUpperCase()).join('') : "")
                                            return <List.Item style={{
                                                backgroundColor: parseInt(item.id) === this.active_notif_id ? '#096dd924' : ''
                                            }}>
                                                <Skeleton avatar title={false} loading={item.loading} active>
                                                    <List.Item.Meta
                                                        avatar={<Tooltip title={<div>
                                                            <p>{created_by.name}</p>
                                                            <p>{created_by.email}</p>
                                                        </div>}>
                                                            <Badge dot={item.status == 'pending'} className='status-indicator-comment status-pending'>
                                                                <Avatar style={{
                                                                    display: 'relative'
                                                                }} className='hand-cursor'>{user_label}</Avatar>
                                                            </Badge>
                                                        </Tooltip>
                                                        }
                                                        title={<div style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            justifyContent: 'space-between'
                                                        }}>
                                                            <span className='heading-3'>{created_by.username}</span>
                                                            <span title={item.created_at}>{moment(item.created_at, "YYYY-MM-DD hh:mmA").fromNow()}</span>
                                                        </div>}
                                                        description={<div>
                                                            {/* <p title={item.created_at}>
                                                            {moment(item.created_at, "YYYY-MM-DD hh:mmA").fromNow()}
                                                    </p> */}
                                                            <p className='sub-heading-3  word-break'>
                                                                {item.remark}
                                                            </p>
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                <div>
                                                                    <Row type='flex' justify='space-between' style={{ width: 'fit-content' }}>
                                                                        {reference.rule_id &&
                                                                            <Tag color={"#2db7f5"}
                                                                                className='tag-orange'
                                                                                style={{ marginBottom: 4 }}>For: {recon_rule.name}
                                                                            </Tag>
                                                                        }
                                                                        {
                                                                            item.date && <Tag color="#108ee9" className='tag-orange' style={{ marginBottom: 4 }}>
                                                                                Follow Up : {item.date}
                                                                            </Tag>
                                                                        }
                                                                    </Row>
                                                                    <Row>
                                                                        {
                                                                            created_by.username == user_data.username &&
                                                                            item.status == 'pending' &&
                                                                            !completed_comment_ids.includes(item.id)
                                                                            &&
                                                                            <Button
                                                                                // color={COLORS.primary}
                                                                                size='small'
                                                                                type='primary'
                                                                                loading={processing_id == item.id}
                                                                                disabled={processing_id == item.id}
                                                                                title="Complete Task"
                                                                                icon={<DoneAll style={{ width: 12, marginRight: 6 }} />}
                                                                                className='hand-cursor'
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        processing_id: item.id
                                                                                    })
                                                                                    this.mark_done_followups.forId(item.id).execute()
                                                                                }}
                                                                                style={{ margin: 4, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>Done
                                                                            </Button>
                                                                        }
                                                                    </Row>
                                                                    {/* {item.date&&<Tag color="#108ee9">For: {item.date}</Tag>}  */}
                                                                </div>
                                                                {/* <div>
                            <Badge status='default' text={recon_rule.name}/>
                            </div> */}
                                                            </div>
                                                        </div>}
                                                    />
                                                    {/* <div>content</div> */}
                                                </Skeleton>
                                            </List.Item>
                                        }}
                                    />
                                </React.Fragment>
                        }
                    </Collapse.Panel>
                    <Collapse.Panel header={<span className='heading-2'>Add Comment / Follow up</span>} key='action'>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>

                            <FilterFixedInput label="Select Process" labelStyle={{
                                color: "#000000", marginBottom: 10
                            }}>
                                <Radio.Group buttonStyle='solid' size='small' onChange={(e) => {
                                    this.stateUpdater('comment_data', 'rule_id', e.target.value)
                                }} value={comment_data.rule_id}>
                                    {total_process_list.map((item) => {
                                        return <Radio style={{
                                            margin: 4, display: 'block',
                                            height: '30px',
                                            lineHeight: '30px'
                                        }} value={item.id}>{item.name}</Radio>
                                    })}
                                </Radio.Group>
                            </FilterFixedInput>
                            <FilterFixedInput label="Type of Comment"
                                labelStyle={{
                                    color: "#000000", marginBottom: 10
                                }}
                                containerStyle={{
                                    marginTop: 16
                                }}>
                                <Select
                                    placeholder={"Type"}
                                    style={{
                                        width: '100%'
                                    }}
                                    value={comment_data.type}
                                    onChange={(value) => {
                                        this.stateUpdater('comment_data', 'type', value)
                                    }}
                                >
                                    <Select.Option key={0} value={0}>
                                        Remark
                                    </Select.Option>
                                    <Select.Option key={1} value={1}>
                                        Follow up
                                    </Select.Option>
                                </Select>
                            </FilterFixedInput>

                            {comment_data.type == 1 && <FilterFixedInput label="Follow Up Date"
                                labelStyle={{
                                    color: "#000000", marginBottom: 10
                                }}
                                containerStyle={{
                                    marginTop: 16
                                }}>
                                <DatePicker
                                    placeholder="Follow up Date"
                                    style={{
                                        width: '100%'
                                    }}
                                    value={comment_data.date ? (moment(comment_data.date, "YYYY-MM-DD")) : null}
                                    onChange={(date, dateString) => {
                                        this.stateUpdater('comment_data', 'date', dateString)
                                    }}
                                    format="YYYY-MM-DD"
                                >
                                </DatePicker>
                            </FilterFixedInput>}

                            <FilterFixedInput label={<div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 10
                            }}>
                                <div>Comment</div>
                                {/* ADD FOR CIVIL */}
                                {APP_CONFIG.civil && <Tooltip key={`comment-hint`} title={<div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 20,

                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        fontSize: 14,
                                        fontWeight: 'bold',
                                    }}>Use below templates for comment</div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 20,
                                        maxHeight: 300,
                                        maxWidth: 250,
                                        overflow: 'scroll'
                                    }}>
                                        {REFERENCE_FOR_CIVIL.map((txt, index) => {
                                            return <div key={"comment-hint" + index} style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 6,
                                                fontSize: 14
                                            }}>
                                                {/* <div style={{
                                                    fontSize: 14
                                                }}>Title of Reference</div> */}
                                                <div className='comment-reference-label'>{txt}</div>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-between'
                                                }}>

                                                    <div className='comment-reference-use' onClick={() => {
                                                        this.stateUpdater('comment_data', 'remark', txt);
                                                    }}>Use This</div>
                                                    <div className='comment-reference-use' onClick={() => {
                                                        this.stateUpdater('comment_data', 'remark', txt, () => {
                                                            this.post_comments.forId(this.props.dataID).execute(comment_data)
                                                        });

                                                    }}>Use {"&"} Submit</div>
                                                </div>

                                            </div>
                                        })}
                                    </div>
                                </div>}>
                                    <div className='hand-cursor'>&#9432;</div>
                                </Tooltip>}
                            </div>}
                                labelStyle={{
                                    color: "#000000", marginBottom: 10
                                }}
                                containerStyle={{
                                    marginTop: 16
                                }}>
                                <Input.TextArea
                                    autoSize={{
                                        minRows: 4, maxRows: 4
                                    }}
                                    placeholder="Comment"
                                    value={comment_data.remark}
                                    onChange={(e) => {
                                        this.stateUpdater('comment_data', 'remark', e.target.value)
                                    }}>

                                </Input.TextArea>
                            </FilterFixedInput>
                            {/* 
                    <label style={{marginBottom:4,marginTop:6}}>Select Process</label>
                    <Radio.Group buttonStyle='solid' size='small' onChange={(e) => {
                        this.stateUpdater('comment_data', 'rule_id', e.target.value)
                    }} value={comment_data.rule_id}>
                        {total_process_list.map((item) => {
                            return <Radio style={{
                                margin: 4, display: 'block',
                                height: '30px',
                                lineHeight: '30px'
                            }} value={item.id}>{item.name}</Radio>
                        })}
                    </Radio.Group>
                    <label style={{marginBottom:4,marginTop:6}}>Type</label>
                    <Select
                        placeholder={"Type"}
                        value={comment_data.type}
                        onChange={(value) => {
                            this.stateUpdater('comment_data', 'type', value)
                        }}
                    >
                        <Select.Option key={0} value={0}>
                            Remark
                    </Select.Option>
                        <Select.Option key={1} value={1}>
                            Follow up
                    </Select.Option>
                    </Select>

                    {comment_data.type == 1 && <React.Fragment>
                        <label style={{marginBottom:4,marginTop:6}}>Select Date</label>
                        <DatePicker
                            placeholder="Follow up Date"
                            value={comment_data.date ? (moment(comment_data.date, "YYYY-MM-DD")) : null}
                            onChange={(date, dateString) => {
                                this.stateUpdater('comment_data', 'date', dateString)
                            }}
                            format="YYYY-MM-DD"
                        >

                        </DatePicker>
                    </React.Fragment>}
                    <label style={{marginBottom:4,marginTop:6}}>Remark</label>
                    <Input.TextArea
                        rows={2}
                        value={comment_data.remark}
                        onChange={(e) => {
                            this.stateUpdater('comment_data', 'remark', e.target.value)
                        }}>

                    </Input.TextArea> */}

                            <Row type='flex' style={{ marginTop: 16 }}>

                                <CustomButton
                                    className='primary-btn'
                                    style={{ marginLeft: 0 }}
                                    onClick={() => {
                                        // console.log(this.props,list)
                                        this.post_comments.forId(this.props.dataID).execute(comment_data)

                                    }}
                                    disabled={post_comments_res.fetching}
                                    label="SUBMIT"
                                />
                                {/* <Button
                        
                            type='primary'
                            onClick={() => {
                                // console.log(this.props,list)
                                this.post_comments.forId(this.props.dataID).execute(comment_data)

                            }}
                            loading={post_comments_res.fetching}>
                            Submit
                    </Button> */}
                            </Row>


                        </div>

                    </Collapse.Panel>

                </Collapse>
                {/* <Row type='flex' justify='space-between'>
                    <Title level={2} type='secondary'>Recent Activities</Title>
                    <Button type='link' icon={comments_res.fetching ? "loading" : ""} style={{ fontSize: 30 }}></Button>
                </Row> */}



            </div>
        )
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.dataID !== prevProps.dataID) {
            // this.list_comments.forId(this.props.dataID).execute()
            this.current_page = 1
            this.setState({
                comment_data: { type: 0 },
                initLoading: true,
                loading: false,
                final_data: false,
                data: [],
                list: [],
            }, () => {
                this.list_comments.forId(this.props.dataID).
                    config({
                        params: {
                            per_page: count,
                            page: 1
                        }
                    }).callbacks((success) => {
                        let pagination = (success.meta.pagination || "0/0").split("/");
                        let final_data = false;
                        if (pagination[0] >= pagination[1]) {
                            final_data = true
                        }
                        this.setState({
                            initLoading: false,
                            data: success.result.rows,
                            list: success.result.rows,
                            final_data: final_data
                        })
                    }).execute();
            }
            );
            // this.get_details.forId(this.props.match.params.id).execute()
            // fetch the new product based and set it to the state of the component
        };
    };

}

export default withRouter(withDomains(CommentPage, "allData", "myTask"))
